import React, { useState, useEffect } from 'react';
import {
  MapIcon,
  SearchIcon,
  SortAscIcon,
  SortDescIcon,
  TableViewIcon,
  GridViewIcon,
  SelectDownIcon,
  SelectUpIcon,
} from 'tt-ui-lib/icons';
import { Box, ButtonBase, IconButton, InputBase, MenuItem, Select, Grid } from '@mui/material';
import styles from '../../CommunityPage.module.scss';

const Filter = ({
  setActiveCountry,
  countries,
  changeActiveMode,
  setFilters,
  setPage,
  searchValue,
  changeSearchValue,
  activeRole,
  activeMode,
  setFilterCreatedAt,
  filterCreatedAt,
}) => {
  const [select, setSelect] = useState('all');
  const [filterType, setFilterType] = useState(true);

  const changeOrder = () => {
    if (activeRole === 'companies') {
      setFilterCreatedAt(!filterCreatedAt);
    } else if (activeRole !== 'companies' && filterType) {
      setFilters((current) => ({ ...current, order_by: 'created_at', page: 1 }));
    } else {
      setFilters((current) => ({ ...current, order_by: null, page: 1 }));
    }
    setPage(1);
    setFilterType(!filterType);
  };

  useEffect(() => {
    setSelect('all');
    setActiveCountry('all');
  }, [activeRole]);

  useEffect(() => {
    localStorage.setItem('mode', activeMode);
  }, [activeMode]);

  return (
    <Box className={styles.filterContent}>
      <Grid
        container
        style={activeMode === 'map' ? { justifyContent: 'flex-end' } : null}
        spacing={2}
      >
        {activeMode !== 'map' && (
          <Grid item xs={12} md={8} lg={8} xl={8}>
            <div className={styles.inputGroup}>
              <InputBase
                className={styles.searchInput}
                placeholder="Search"
                value={searchValue}
                onChange={(e) => changeSearchValue(e.target.value)}
              />
              <div className={styles.searchIcon}>
                <SearchIcon style={{ width: 20, height: 20 }} />
              </div>
            </div>
          </Grid>
        )}
        {/* {activeMode === 'map' && (
          <Grid item container xs={12} md={8} lg={8} xl={8} className={styles.inputGroup}>
            <Grid item xs={12} md={6} className={styles.filterSelectContent}>
              <Select
                value={select}
                className={styles.filterSelect}
                onChange={(e) => {
                  setSelect(e.target.value);
                  setActiveCountry(e.target.value);
                }}
                size="medium"
                placeholder="Countries"
              >
                <MenuItem className={styles.menuItem} disabled>
                  Countries
                </MenuItem>
                <MenuItem value="all" className={styles.menuItem}>
                  All Countries
                </MenuItem>
                {countries.length > 0 &&
                  countries.map(
                    (element) =>
                      element.country_code !== '' && (
                        <MenuItem value={element.country_code} className={styles.menuItem}>
                          {element.country}
                        </MenuItem>
                      ),
                  )}
              </Select>
            </Grid>
          </Grid>
        )} */}
        <Grid
          className={activeMode === 'map' ? styles.mapGrid : null}
          item
          xs={12}
          md={4}
          lg={4}
          xl={4}
        >
          <Box className={styles.filterActions}>
            {activeMode !== 'map' && (
              <Box
                onClick={() => changeOrder()}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  height: '100%',
                  justifyContent: 'space-between',
                  background: '#FFF',
                  borderRadius: '12px',
                  width: '100%',
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <IconButton style={{ padding: 0, width: 30, height: 30, marginLeft: 10 }}>
                    {filterType ? (
                      <SortAscIcon className={styles.filterIcons} />
                    ) : (
                      <SortDescIcon className={styles.filterIcons} />
                    )}
                  </IconButton>
                  <ButtonBase className={styles.filterNewFirst}>New first</ButtonBase>
                </div>
                {filterType ? (
                  <SelectDownIcon className={styles.selectArrow} />
                ) : (
                  <SelectUpIcon className={styles.selectArrow} />
                )}
              </Box>
            )}
            <Box className={styles.buttonsGroup}>
              <IconButton style={{ padding: 0 }} onClick={() => changeActiveMode('grid')}>
                <GridViewIcon
                  className={activeMode === 'grid' ? styles.activeIcon : styles.filterIcons}
                />
              </IconButton>
              <IconButton style={{ padding: 0 }} onClick={() => changeActiveMode('list')}>
                <TableViewIcon
                  className={activeMode === 'list' ? styles.activeIcon : styles.filterIcons}
                />
              </IconButton>
              <IconButton style={{ padding: 0 }} onClick={() => changeActiveMode('map')}>
                <MapIcon
                  className={activeMode === 'map' ? styles.activeIcon : styles.filterIcons}
                />
              </IconButton>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Filter;
